import { render, staticRenderFns } from "./EducationAutocomplete.vue?vue&type=template&id=29d072bb&"
import script from "./EducationAutocomplete.vue?vue&type=script&lang=js&"
export * from "./EducationAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports